import { SporsmalType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { Blindveisporsmal } from '../reducer/sporsmalsflyt-types';
import { CurrentSporsmalSide } from '../sporsmalSide/sporsmalSide-types';

export interface CurrentBlindveisporsmal {
    type: SporsmalType.Blindvei;
    sporsmal: Blindveisporsmal;
}

export const isBlindveisporsmal = (currentSporsmal: CurrentSporsmal): currentSporsmal is CurrentBlindveisporsmal =>
    currentSporsmal.type === SporsmalType.Blindvei;

const blindveiSporsmalIds = (blindveiSporsmalList: CurrentSporsmal[]): string[] =>
    blindveiSporsmalList.map((blindveiSporsmal) => blindveiSporsmal.sporsmal.id);

export const isBlindveisporsmalVisibleOnSporsmalside = (
    currentSporsmal: CurrentSporsmal,
): currentSporsmal is CurrentSporsmalSide => {
    if (currentSporsmal.type === SporsmalType.SporsmalSide) {
        const blindveiSporsmalList: CurrentSporsmal[] =
            currentSporsmal.sporsmalsflytCollection.currentSporsmalList.filter((sporsmal) =>
                isBlindveisporsmal(sporsmal),
            );
        if (blindveiSporsmalList) {
            return currentSporsmal.sporsmalsflytCollection.sporsmalVisibilityState.some(
                (sporsmal) => blindveiSporsmalIds(blindveiSporsmalList).includes(sporsmal.sporsmalId) && sporsmal.show,
            );
        }
    }
    return false;
};
